class IntersectionController {
  constructor(host, options) {
    this._observer = null;
    this.isIntersecting = false;
    this.entries = [];
    this._host = host;
    this._options = options ?? {};
    host.addController(this);
  }
  hostConnected() {
    this._observer = new IntersectionObserver((entries) => {
      this.entries = entries;
      this.isIntersecting = entries.some((e) => e.isIntersecting);
      this._host.requestUpdate();
    }, this._options);
    this._observer.observe(this._host);
  }
  hostDisconnected() {
    this._observer?.disconnect();
    this._observer = null;
  }
}
class MediaQueryController {
  constructor(host, query) {
    this._mql = null;
    this._handler = null;
    this.matches = false;
    this._host = host;
    this._query = query;
    host.addController(this);
  }
  hostConnected() {
    this._mql = window.matchMedia(this._query);
    this.matches = this._mql.matches;
    this._handler = (e) => {
      this.matches = e.matches;
      this._host.requestUpdate();
    };
    this._mql.addEventListener("change", this._handler);
  }
  hostDisconnected() {
    if (this._mql && this._handler) {
      this._mql.removeEventListener("change", this._handler);
    }
    this._mql = null;
    this._handler = null;
  }
}
export {
  IntersectionController,
  MediaQueryController
};
//# sourceMappingURL=controllers.js.map
